import { cn } from '@/lib/ui/utils';

/** Figma Web app → node 4427:54 step card shell (406×477). */
export const howItWorksStepCardClass: string = cn(
  'flex h-[477px] flex-col overflow-hidden rounded-card bg-background-primary',
);

/** Figma 4427:65 Visual/html animation band (406×333). */
export const howItWorksStepVisualClass: string = cn(
  'relative flex h-[333px] w-full shrink-0 items-center justify-center overflow-hidden bg-background-primary',
);

/** Figma 4427:63 copy footer (406×144, 24px padding, bottom-aligned text). */
export const howItWorksStepCopyFooterClass: string = cn('flex h-[144px] shrink-0 items-end p-6');
